"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2535],{

/***/ 79835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-qa.forumm.to/2863/_next/static/media/header-background.10993a0a.png","height":480,"width":1924,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACBAMAAACXuoDeAAAAGFBMVEVq48Zn2NFjy9tgwOZYrOtJjeg8ceYwVuSCP/gQAAAAEklEQVR42mMoCzESYCgLMRIAAAvWAhnMYywNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 69341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96963);
/* harmony import */ var _libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24499);
/* harmony import */ var _base_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51773);
/* harmony import */ var _components_landing_Media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11390);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53510);








const EventsView = (param)=>{
    let { events , types , title , currency , justify  } = param;
    const { profile , isOrganizer , isAdmin , canEditEvent  } = (0,_libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)();
    const userId = profile === null || profile === void 0 ? void 0 : profile.userId;
    const [viewAll, setViewAll] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const isSpeaker = (event)=>{
        var ref;
        if (!event || !profile) return false;
        return !!((ref = event.speakers) === null || ref === void 0 ? void 0 : ref.find((f)=>{
            return f.email === (profile === null || profile === void 0 ? void 0 : profile.email);
        }));
    };
    // TODO: Define types correctly
    const renderEventCard = (e)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        if (!e) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        var ref12, ref13;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_landing_Media__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            eventId: e.eventId,
            url: (e === null || e === void 0 ? void 0 : (ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) === "FUNDRAISER" ? "/donation/".concat(e.event.donationUrl) : "/event/".concat(e.eventId),
            type: e.event.eventType,
            title: (ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.title,
            description: (ref2 = e.event) === null || ref2 === void 0 ? void 0 : ref2.shortDescription,
            image: (ref12 = (ref3 = e.event) === null || ref3 === void 0 ? void 0 : ref3.bannerImage) !== null && ref12 !== void 0 ? ref12 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            banner: (ref13 = (ref4 = e.event) === null || ref4 === void 0 ? void 0 : ref4.thumbnailImage) !== null && ref13 !== void 0 ? ref13 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            organization: e === null || e === void 0 ? void 0 : (ref5 = e.event) === null || ref5 === void 0 ? void 0 : ref5.organizationName,
            startTime: (ref6 = e.event) === null || ref6 === void 0 ? void 0 : ref6.startDateTime,
            endTime: (ref7 = e.event) === null || ref7 === void 0 ? void 0 : ref7.endDateTime,
            canEdit: canEditEvent(e),
            isSpeaker: isSpeaker(e),
            isPublished: e.isPublished,
            attendees: e.eventId === "31fffe01-557f-4c3c-a7f3-cb1ec9772277" ? "306" : (ref8 = e.attendees) === null || ref8 === void 0 ? void 0 : ref8.length,
            donors: (ref9 = e.fundraising) === null || ref9 === void 0 ? void 0 : ref9.donors,
            goal: (ref10 = e.fundraising) === null || ref10 === void 0 ? void 0 : ref10.goal,
            raised: (ref11 = e.fundraising) === null || ref11 === void 0 ? void 0 : ref11.raised,
            currency: currency !== null && currency !== void 0 ? currency : "GBP"
        }, e.eventId);
    };
    // TODO: Define types correctly
    const renderEvents = (data)=>{
        // TODO: Define types correctly
        return data.sort((a, b)=>(0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__/* .isEventAfter */ .r3)(a, b)).map((e)=>{
            var ref, ref1;
            if (((ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) == null) {
                return null;
            }
            if (!types.includes((ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.eventType)) {
                return null;
            }
            if (title.length > 0 && !e.event.title.toLowerCase().includes(title.toLowerCase())) {
                return null;
            }
            return renderEventCard(e);
        });
    };
    const justifyClass = justify === "center" ? "" : " sm:justify-start sm:items-start";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
        className: "flex sm:-mx-4 md:w-[110%] max-w-[1530px] flex-wrap justify-center items-center ".concat(justifyClass),
        children: [
            viewAll ? renderEvents(events) : renderEvents(events === null || events === void 0 ? void 0 : events.slice(0, 8)),
            events.length <= 8 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : !viewAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "w-full justify-center flex mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                    className: "sm:min-w-[15rem] text-xs sm:text-sm",
                    title: "View All",
                    type: "primary",
                    textColor: "white",
                    onClick: ()=>setViewAll(true)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventsView);


/***/ }),

/***/ 8194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DateTimeInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9198);
/* harmony import */ var react_datepicker__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_datepicker__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5779);
/* harmony import */ var _components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73912);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53510);








const DatePicker = (react_datepicker__WEBPACK_IMPORTED_MODULE_7___default());
const validateDate = (value, validations)=>{
    if (validations) {
        const current = moment__WEBPACK_IMPORTED_MODULE_2___default()(value);
        const greaterThanDate = moment__WEBPACK_IMPORTED_MODULE_2___default()(validations.greaterThanDate);
        if (current <= greaterThanDate) {
            return "Event cannot end before it starts.";
        }
    }
    return null;
};
/**
 * Primary UI component for text input
 */ const DateTimeInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , required , validations , filterDate , filterTime , id , clickIdOnChange , dateOnly =false , placeholderText ="Pick a date/time" , inputClass ="" , show =true , labelBgColour , tooltip , initialDate , tz =0 , error  } = param;
    const errorMessage = error !== null && error !== void 0 ? error : validateDate(value, validations);
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    const [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // Autohide tooltip if the input is not required.
        if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.toLowerCase().includes("require")) && !required) setShowTooltip(false);
    }, [
        tooltip,
        required
    ]);
    const closeAction = (id)=>{
        setTimeout(()=>{
            const element = document.getElementById(id);
            if (element) {
                element.click();
            }
        }, 100);
    };
    const doDatePartsMatch = (firstDate, secondDate)=>{
        if (!firstDate || !secondDate) return false;
        return firstDate.getDate() === secondDate.getDate() && firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear();
    };
    const hasTimeChanged = (originalTime, newTime)=>{
        if (!originalTime || !newTime) return true;
        return originalTime.getHours() !== newTime.getHours() || originalTime.getMinutes() !== newTime.getMinutes() || originalTime.getSeconds() !== newTime.getSeconds();
    };
    const handleChange = (date)=>{
        const payload = date === null || date === void 0 ? void 0 : date.toISOString();
        onChange && onChange(payload !== null && payload !== void 0 ? payload : "", false);
        if (clickIdOnChange && date) {
            const current = new Date(value);
            if (doDatePartsMatch(current, date) && hasTimeChanged(current, date)) {
                closeAction(clickIdOnChange);
            }
        }
    };
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            "my-2 flex flex-col",
            className
        ].join(" "),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                style: {
                    backgroundColor: labelBgColour !== null && labelBgColour !== void 0 ? labelBgColour : theme.backgroundColour,
                    zIndex: 10
                },
                className: "absolute text-sm -translate-y-1/2 mb-2 ml-2 ".concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tootilp_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    show: showTooltip,
                    tooltip: tooltip,
                    className: "flex flex-col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DatePicker, {
                id: id || "",
                selected: value ? moment__WEBPACK_IMPORTED_MODULE_2___default()(value).add("h", (ref = tz - (0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_6__/* .getClientTimezoneOffset */ .vM)()) !== null && ref !== void 0 ? ref : 0).toDate() : null,
                onChange: handleChange,
                showTimeSelect: !dateOnly,
                showYearDropdown: true,
                scrollableYearDropdown: true,
                yearDropdownItemNumber: 100,
                openToDate: initialDate !== null && initialDate !== void 0 ? initialDate : new Date(),
                filterDate: filterDate,
                filterTime: filterTime,
                popperClassName: "!z-20",
                required: required,
                timeFormat: "HH:mm",
                timeIntervals: 15,
                autoComplete: "off",
                dateFormat: !dateOnly ? "MMMM d, yyyy HH:mm" : "MMMM d, yyyy",
                placeholderText: placeholderText,
                className: "rounded-2xl transition-all bg-transparent border ".concat(errorMessage ? "text-red-500 border-red-500" : "", " bg-transparent border rounded px-4 py-4 text-sm outline-none cursor-pointer w-full always-on-top ").concat(inputClass)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 ml-2 text-xs text-white",
                children: hint
            }),
            errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 26291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47906);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var voca__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81209);
/* harmony import */ var _ColorPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14857);
/* harmony import */ var _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8194);
/* harmony import */ var _DropdownInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61993);
/* harmony import */ var _FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _PriceInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84456);
/* harmony import */ var _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33923);













const formElements = {
    FileInput: _FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S,
    DateTimeInput: _DateTimeInput__WEBPACK_IMPORTED_MODULE_8__/* .DateTimeInput */ .Y,
    TextInput: _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o,
    PriceInput: _PriceInput__WEBPACK_IMPORTED_MODULE_11__/* .PriceInput */ .t,
    TextAreaInput: _TextAreaInput__WEBPACK_IMPORTED_MODULE_12__/* .TextAreaInput */ .F,
    DropdownInput: _DropdownInput__WEBPACK_IMPORTED_MODULE_9__/* .DropdownInput */ .f,
    ColorPicker: _ColorPicker__WEBPACK_IMPORTED_MODULE_7__/* .ColorPicker */ .z
};
const INPUT_ELEMENTS = [
    "CheckboxInput",
    "DropdownInput"
];
const isProtectedInput = (element)=>{
    var ref, ref1;
    // if ((element.type as any).name === 'CheckboxInput') console.log({ element })
    if ((ref = element.props) === null || ref === void 0 ? void 0 : ref.isProtected) return true;
    if ((ref1 = element.type) === null || ref1 === void 0 ? void 0 : ref1.name) {
        return INPUT_ELEMENTS.includes(element.type.name);
    }
};
const getFormData = function(children, formData, setFormData) {
    let initialFormData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    children.forEach((element, i)=>{
        var ref;
        if ((element === null || element === void 0 ? void 0 : (ref = element.props) === null || ref === void 0 ? void 0 : ref.children) && !isProtectedInput(element)) {
            const { children: childElements  } = element.props;
            if (childElements) {
                const newChildren = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isArray)(childElements) ? [
                    ...childElements
                ] : [
                    childElements
                ];
                initialFormData = {
                    ...initialFormData,
                    ...getFormData(newChildren, formData, setFormData, initialFormData)
                };
                children[i] = children[i].type == _components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    ...element.props,
                    children: newChildren
                }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ...element.props,
                    children: newChildren
                }, i);
            }
        } else {
            var ref1;
            if (!(element === null || element === void 0 ? void 0 : (ref1 = element.props) === null || ref1 === void 0 ? void 0 : ref1.label)) return;
            const { label , required , onChange: existingOnChange  } = element.props;
            const camelCaseLabel = voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(label);
            // console.log({ camelCaseLabel })
            if (camelCaseLabel == null || camelCaseLabel === "") {
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i
                });
            } else {
                var ref2;
                children[i] = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.cloneElement)(element, {
                    ...element.props,
                    key: i,
                    value: formData.hasOwnProperty(camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : "") ? (ref2 = formData[camelCaseLabel !== null && camelCaseLabel !== void 0 ? camelCaseLabel : ""]) === null || ref2 === void 0 ? void 0 : ref2.value : undefined,
                    onChange: (value, invalidData)=>{
                        const isInvalid = [
                            required && value === undefined,
                            invalidData
                        ].some((val)=>val === true);
                        // console.log({ isInvalid })
                        setFormData((currentFormData)=>({
                                ...currentFormData,
                                [camelCaseLabel]: {
                                    value: value,
                                    invalid: isInvalid
                                }
                            }));
                        existingOnChange && existingOnChange(value, invalidData);
                    }
                });
                initialFormData = {
                    ...initialFormData,
                    [camelCaseLabel]: {
                        value: undefined,
                        invalid: required === true
                    }
                };
            }
        }
    });
    return initialFormData;
};
/**
 * Primary UI component for Forms
 */ const Form = (param)=>{
    let { className , children , onSubmit , initialFormData , error , clearFormOnSubmit =false , clearFormOnError =false , clearForm , show =true , ...rest } = param;
    let modifiedChildren = [
        ...children
    ];
    const getInitialFormData = ()=>{
        if (initialFormData) {
            const normalizedFormData = Object.keys(initialFormData).reduce((acc, key)=>{
                acc[key] = {
                    value: initialFormData[key],
                    invalid: false
                };
                return acc;
            }, {});
            getFormData(modifiedChildren, normalizedFormData, ()=>{});
            return normalizedFormData;
        } else {
            return getFormData(modifiedChildren, {}, ()=>{});
        }
    };
    const [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(getInitialFormData());
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if (!!clearForm) setFormData(getInitialFormData());
    }, [
        clearForm
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setFormData(getInitialFormData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        setErrorMessage(error || "");
    }, [
        error
    ]);
    getFormData(modifiedChildren, formData, setFormData);
    const [errorMessage, setErrorMessage] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("");
    const invalidForm = Object.values(formData).some((element)=>element.invalid);
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        ...rest,
        className: className !== null && className !== void 0 ? className : "",
        onSubmit: async (e)=>{
            e.preventDefault();
            // console.log({ fd: Object.values(formData) })
            if (invalidForm) {
                setErrorMessage("One or more fields are invalid or missing");
                if (clearFormOnError) {
                    setFormData(getInitialFormData());
                }
                return;
            }
            if (onSubmit) {
                const formDataValues = Object.entries(formData).reduce((acc, param)=>{
                    let [key, value] = param;
                    return {
                        ...acc,
                        [voca__WEBPACK_IMPORTED_MODULE_6__/* ["default"].camelCase */ .Z.camelCase(key)]: value.value
                    };
                }, {});
                const errorMessage = await onSubmit(formDataValues);
                if (errorMessage) {
                    setErrorMessage(errorMessage);
                }
            }
            if (clearFormOnSubmit) {
                setFormData(getInitialFormData());
            }
        },
        children: [
            modifiedChildren,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: !!errorMessage || !!invalidForm,
                ignoreTheme: true,
                className: "flex justify-center items-center text-center transition-all ".concat(errorMessage || invalidForm ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold mb-6 sm:mt-0 md:mt-8"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "One or more fields are invalid"
            })
        ]
    });
};


/***/ }),

/***/ 41826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ UPDATE_ORGANISATION; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const UPDATE_ORGANISATION = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  mutation updateOrganisation(\n    $name: String!\n    $organisationType: String\n    $mainColour: String\n    $bannerImage: String\n    $logoImage: String\n    $currency: String\n    $percentage: Float\n    $headerTextOne: String\n    $headerTextTwo: String\n    $dashboardPopupDoNotShowAgain: Boolean\n  ) {\n    updateOrganisation(\n      name: $name\n      organisationType: $organisationType\n      mainColour: $mainColour\n      bannerImage: $bannerImage\n      logoImage: $logoImage\n      currency: $currency\n      percentage: $percentage\n      headerTextOne: $headerTextOne\n      headerTextTwo: $headerTextTwo\n      dashboardPopupDoNotShowAgain: $dashboardPopupDoNotShowAgain\n    ) {\n      success\n    }\n  }\n");


/***/ }),

/***/ 11734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ libs_useFileUploader; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/media/uploadMedia.ts

const UPLOAD_MEDIA = (0,_generated/* graphql */.B)("\n  mutation UploadMedia($input: MediaUploadInput!) {\n    uploadMedia(input: $input) {\n      preSignedUrl\n      uploadedFileUrl\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./libs/useFileUploader.ts



const useFileUploader = ()=>{
    const [uploadMedia] = (0,useMutation/* useMutation */.D)(UPLOAD_MEDIA);
    const generateSafeFileName = (name)=>{
        return (0,v4/* default */.Z)();
    };
    const uploadFile = async (file)=>{
        var ref, ref1;
        const response = await uploadMedia({
            variables: {
                input: {
                    contentType: "application/x-www-form-urlencoded",
                    filename: generateSafeFileName(file.name)
                }
            }
        });
        const preSignedUrl = (ref = response.data) === null || ref === void 0 ? void 0 : ref.uploadMedia.preSignedUrl;
        const uploadedFileUrl = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.uploadMedia.uploadedFileUrl;
        await fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file.type
            }
        });
        return uploadedFileUrl !== null && uploadedFileUrl !== void 0 ? uploadedFileUrl : "";
    };
    return uploadFile;
};
/* harmony default export */ var libs_useFileUploader = (useFileUploader);


/***/ }),

/***/ 48332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ clearLS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6812);


function useLSFirst(key, query, props) {
    const [localData, setLocalData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{
        // Retrieve initial data from local storage
        const storedData = localStorage.getItem(key);
        return storedData ? JSON.parse(storedData) : null;
    });
    const { loading , data: serverData , ...rest } = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(query, props);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (serverData) {
            // Update local storage when new data is fetched
            localStorage.setItem(key, JSON.stringify(serverData));
            // Sync local data with the server data
            setLocalData(serverData);
        }
    }, [
        serverData,
        key
    ]);
    // Return loading state and localData as a fallback for `data`
    return {
        loading,
        data: localData || serverData,
        ...rest
    };
}
const clearLS = (keys)=>{
    keys.forEach((key)=>localStorage.removeItem(key));
};
/* harmony default export */ __webpack_exports__["Z"] = (useLSFirst);


/***/ }),

/***/ 42535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OrganizerLaunchPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./components/inputs/FileInput.tsx + 5 modules
var FileInput = __webpack_require__(40296);
// EXTERNAL MODULE: ./libs/useFileUploader.ts + 1 modules
var useFileUploader = __webpack_require__(11734);
// EXTERNAL MODULE: ./libs/useLSFirst.ts
var useLSFirst = __webpack_require__(48332);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/event/EventsView.tsx
var EventsView = __webpack_require__(69341);
// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
// EXTERNAL MODULE: ./components/chat/EventChatBox.tsx + 12 modules
var EventChatBox = __webpack_require__(62293);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 9 modules
var Wrapper = __webpack_require__(44066);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
;// CONCATENATED MODULE: ./layouts/DashboardLayout.tsx






const DashboardLayout = (param)=>{
    let { children  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.ZP, {
        className: "h-screen",
        wrapperClasses: "flex flex-col flex-1",
        showFooter: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            mode: "wait",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-1",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventChatBox/* default */.Z, {
                        showEventPeopleTab: true,
                        showUniversityUsers: true,
                        defaultChatName: (profile === null || profile === void 0 ? void 0 : profile.university) != null || (profile === null || profile === void 0 ? void 0 : profile.company) != null ? "".concat((ref = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.company, " Chat") : "General Chat",
                        defaultChatId: (profile === null || profile === void 0 ? void 0 : profile.university) != null || (profile === null || profile === void 0 ? void 0 : profile.company) != null ? "".concat((ref1 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref1 !== void 0 ? ref1 : profile === null || profile === void 0 ? void 0 : profile.company, "-general") : "general-chat"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var layouts_DashboardLayout = (DashboardLayout);

// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 3 modules
var util = __webpack_require__(53510);
// EXTERNAL MODULE: ./components/inputs/Form.tsx
var Form = __webpack_require__(26291);
;// CONCATENATED MODULE: ./components/inputs/OrganizationBannerEditPopup.tsx












const OrganizationBannerEditPopup = (param)=>{
    let { onSave , headerTextOne , headerTextTwo  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    // const [form, setForm] = useState<{
    //   title?: string
    //   subtitle: string
    // }>({
    //   title: '',
    //   subtitle: '',
    // })
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    // const handleSave = () => {
    //   const hasTitle =
    //     form.title && form.title.length >= 5 && form.title.length < 200
    //   const hasSubtitle =
    //     form.subtitle && form.subtitle.length >= 5 && form.subtitle.length < 200
    //   if (hasTitle && hasSubtitle) {
    //     onSave(form?.title ?? '', form?.subtitle ?? '')
    //     setIsOpen(false)
    //   }
    // }
    // useEffect(() => {
    //   if (isOpen) {
    //     setForm({
    //       ...form,
    //       title: headerTextOne ?? '',
    //       subtitle: headerTextTwo ?? '',
    //     })
    //   }
    // }, [isOpen])
    const textEditModal = /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen || false,
        setShow: (val)=>{
            if (setIsOpen) setIsOpen(val);
        },
        className: "p-0",
        version: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            initialFormData: {
                bannerTitle: headerTextOne !== null && headerTextOne !== void 0 ? headerTextOne : "",
                bannerSubtitle: headerTextTwo !== null && headerTextTwo !== void 0 ? headerTextTwo : ""
            },
            onSubmit: async (data)=>{
                try {
                    console.log({
                        data
                    });
                    const { bannerTitle , bannerSubtitle  } = data;
                    onSave(bannerTitle, bannerSubtitle);
                    setIsOpen(false);
                } catch (error) {
                    console.error(error);
                    setIsOpen(false);
                    var _message;
                    return (_message = error.message) !== null && _message !== void 0 ? _message : "Failed to sign in";
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "sticky top-0 z-10 flex justify-between items-center p-4 rounded-tl-xl rounded-tr-xl",
                    style: {
                        backgroundColor: theme.foregroundColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "flex items-center justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-bold",
                                children: "Configure your organisation heading text"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                            className: "w-6 h-6 cursor-pointer",
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "relative p-10 pt-3 pb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                validations: {
                                    minLength: {
                                        value: 5,
                                        message: "The Title must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 200,
                                        message: "The Title must be less than 200 characters"
                                    }
                                },
                                label: "Banner Title",
                                placeholder: "Your Banner Title",
                                required: true
                            }, "title_edit_field")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                validations: {
                                    minLength: {
                                        value: 5,
                                        message: "The Subtitle must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 200,
                                        message: "The Subtitle must be less than 200 characters"
                                    }
                                },
                                label: "Banner Subtitle",
                                placeholder: "Your Banner Subtitle",
                                required: true
                            }, "subtitle_edit_field")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Save",
                                buttonType: "submit",
                                size: "auto"
                            })
                        })
                    ]
                })
            ]
        })
    });
    const contrastColor = (0,util/* getContrastColor */.RN)(theme.highlightColour);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        onClick: ()=>setIsOpen(true),
        className: "absolute top-5 -right-5 sm:top-0 sm:right-0 !h-[33px] !w-[33px] inline-block rounded-full items-center cursor-pointer text-white ml-2 transform",
        style: {
            backgroundColor: theme.highlightColour
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdEdit */.zmo, {
                className: "absolute top-[8px] left-[9px] h-4 w-4 inline-block hover:animate-heartbeat",
                style: {
                    color: contrastColor
                }
            }),
            textEditModal
        ]
    });
};
/* harmony default export */ var inputs_OrganizationBannerEditPopup = (OrganizationBannerEditPopup);

;// CONCATENATED MODULE: ./components/dashboard/SearchEvent.tsx





function SearchEvent(param) {
    let { searchTerm , setSearchTerm  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [value, setValue] = (0,react.useState)(searchTerm);
    const isDarkTheme = theme.type === "DARK";
    (0,react.useEffect)(()=>{
        setSearchTerm(value);
    }, [
        setSearchTerm,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex p-1 border ".concat(isDarkTheme ? "border border-panel-gray" : "border border-forumm-menu-border", " rounded-3xl"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                placeholder: "Find your event",
                className: "ml-4 outline-none w-full text-xs sm:text-sm hover:animate-heartbeat",
                value: value,
                onChange: (e)=>setValue(e.target.value),
                style: {
                    backgroundColor: "transparent"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                title: "Search",
                className: "text-xs sm:text-sm",
                onClick: ()=>setSearchTerm(value)
            })
        ]
    });
}
/* harmony default export */ var dashboard_SearchEvent = (SearchEvent);

// EXTERNAL MODULE: ./graphql/organisation/updateOrganisation.ts
var organisation_updateOrganisation = __webpack_require__(41826);
;// CONCATENATED MODULE: ./components/dashboard/StylingModal.tsx











const StylingModal = (param)=>{
    let { organisationData  } = param;
    const { push  } = (0,next_router.useRouter)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [doNotShowAgain, setDoNotShowAgain] = (0,react.useState)(false);
    const [updateOrganisation] = (0,useMutation/* useMutation */.D)(organisation_updateOrganisation/* UPDATE_ORGANISATION */.$);
    (0,react.useEffect)(()=>{
        if (organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) {
            const doNotShowAgain = organisationData === null || organisationData === void 0 ? void 0 : organisationData.dashboardPopupDoNotShowAgain;
            if (doNotShowAgain) return;
            const hasCustomized = !!((organisationData === null || organisationData === void 0 ? void 0 : organisationData.bannerImage) && (organisationData === null || organisationData === void 0 ? void 0 : organisationData.logoImage) && (organisationData === null || organisationData === void 0 ? void 0 : organisationData.mainColour));
            if (!hasCustomized) {
                setIsOpen(true);
            }
        }
    }, [
        organisationData
    ]);
    const handleSave = async ()=>{
        if (organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) {
            updateOrganisation({
                variables: {
                    name: organisationData.name,
                    dashboardPopupDoNotShowAgain: doNotShowAgain
                }
            });
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen || false,
        setShow: (val)=>{
            if (setIsOpen) setIsOpen(val);
        },
        title: "Modal Title",
        className: "p-0",
        version: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "overflow-auto scrollbar-hide rounded rounded-xl ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "sticky top-0 z-10 flex justify-between items-center p-4 rounded-tl-xl rounded-tr-xl",
                    style: {
                        backgroundColor: theme.foregroundColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "flex items-center justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-bold",
                                children: "\uD83C\uDFA8 Enhance Your Brand Identity Now"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                            className: "w-6 h-6 cursor-pointer",
                            onClick: ()=>{
                                handleSave();
                                setIsOpen(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "relative p-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "Let",
                                "'",
                                "s Add Some Color to Your World!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "We",
                                "'",
                                "ve noticed that your organisation",
                                "'",
                                "s dashboard is still in its default attire. It",
                                "'",
                                "s time to dress it up! Customize your dashboard now to make it truly yours and resonate with your brand",
                                "'",
                                "s unique identity."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "Just a few clicks and you",
                                "'",
                                "ll transform your dashboard from generic to iconic."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Complete your brand identity now!",
                                type: "primary",
                                size: "auto",
                                onClick: ()=>{
                                    handleSave();
                                    push("/organisation-settings");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mt-8",
                            children: [
                                "Let your organisation",
                                "'",
                                "s character shine through every aspect of your dashboard. This is more than customization; it",
                                "'",
                                "s about creating an experience that aligns with your vision and engages your audience."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "text-sm mb-1 mt-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    checked: doNotShowAgain,
                                    onChange: ()=>setDoNotShowAgain(!doNotShowAgain),
                                    className: "mr-2 pt-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold cursor-pointer",
                                    onClick: ()=>setDoNotShowAgain(!doNotShowAgain),
                                    children: "Do not show again"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Skip",
                                type: "secondary",
                                size: "auto",
                                onClick: handleSave
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var dashboard_StylingModal = (StylingModal);

// EXTERNAL MODULE: ./public/header-background.png
var header_background = __webpack_require__(79835);
// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/getDashboardEvents.ts

const GET_DASHBOARD_EVENTS = (0,_generated/* graphql */.B)("\n  query GetDashboardEvents {\n    getDashboardEvents {\n      events {\n        ...EventOverview\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/getMyEventOverviews.ts

const GET_MY_EVENT_OVERVIEWS = (0,_generated/* graphql */.B)("\n  query GetMyEventOverviews {\n    getMyEvents {\n      ...EventOverview\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/getAllEventOverviews.ts

const GET_ALL_EVENT_OVERVIEWS = (0,_generated/* graphql */.B)("\n  query GetAllEventOverviews {\n    getAllPublicEvents {\n      ...EventOverview\n    }\n  }\n");
const GET_ALL_EVENTS_OVERVIEWS = (0,_generated/* graphql */.B)("\n  query GetAllEventsOverviews {\n    getAllEvents {\n      ...EventOverview\n    }\n  }\n");

;// CONCATENATED MODULE: ./pages/dashboard.tsx


























function OrganizerLaunchPage() {
    var ref, ref1, ref2;
    const { profile , canEditEvent  } = (0,useAuth/* useAuth */.aC)();
    const { theme , setTheme  } = (0,useTheme/* useTheme */.Fg)();
    const uploadFile = (0,useFileUploader/* default */.Z)();
    const [updateOrganisation] = (0,useMutation/* useMutation */.D)(organisation_updateOrganisation/* UPDATE_ORGANISATION */.$);
    const [organisationBanner, setOrganisationBanner] = (0,react.useState)();
    const [isReady, setIsReady] = (0,react.useState)(false);
    const [term, setTerm] = (0,react.useState)("");
    const [filterTypes] = (0,react.useState)([
        "ONLINE",
        "IN_PERSON",
        "FUNDRAISER"
    ]);
    const isOrganizer = profile === null || profile === void 0 ? void 0 : (ref = profile.groups) === null || ref === void 0 ? void 0 : ref.includes("organizer");
    const isAdmin = profile === null || profile === void 0 ? void 0 : (ref1 = profile.groups) === null || ref1 === void 0 ? void 0 : ref1.includes("forumm-admin");
    (0,react.useEffect)(()=>{
        if (profile === null || profile === void 0 ? void 0 : profile.email) setIsReady(true);
    }, [
        profile
    ]);
    var ref3, ref4;
    const company = (0,react.useMemo)(()=>{
        return (ref4 = (ref3 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref3 !== void 0 ? ref3 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref4 !== void 0 ? ref4 : "";
    }, [
        profile
    ]);
    const { loading: dashboardEventsLoading , data: dashboardData  } = (0,useLSFirst/* default */.Z)("dashboard-events", GET_DASHBOARD_EVENTS, {});
    const { loading: myEventsLoading , data: myEventsData  } = (0,useLSFirst/* default */.Z)("my-events", GET_MY_EVENT_OVERVIEWS, {});
    const { loading: allEventsLoading , data: allEventsData  } = (0,useLSFirst/* default */.Z)("all-events", GET_ALL_EVENTS_OVERVIEWS, {
        skip: !isOrganizer && !isAdmin
    });
    (0,react.useEffect)(()=>{
        if (profile) {
            console.log("Profile: ", profile === null || profile === void 0 ? void 0 : profile.email, "\nCompany: ", company);
        }
    }, [
        profile
    ]);
    const { loading: organisationLoading , profile: organisationData , ready: organisationReady , refetchOrganisation  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(company);
    var ref5;
    const dashboardEvents = (ref5 = dashboardData === null || dashboardData === void 0 ? void 0 : (ref2 = dashboardData.getDashboardEvents) === null || ref2 === void 0 ? void 0 : ref2.events) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    const myEvents = (ref6 = myEventsData === null || myEventsData === void 0 ? void 0 : myEventsData.getMyEvents) !== null && ref6 !== void 0 ? ref6 : [];
    var ref7;
    const allEvents = (ref7 = allEventsData === null || allEventsData === void 0 ? void 0 : allEventsData.getAllEvents) !== null && ref7 !== void 0 ? ref7 : [];
    const isPubliclyAccessible = (eventItem)=>{
        var ref;
        return !!(eventItem === null || eventItem === void 0 ? void 0 : eventItem.isPublished) && (eventItem === null || eventItem === void 0 ? void 0 : (ref = eventItem.event) === null || ref === void 0 ? void 0 : ref.publiclyListed) !== false;
    };
    const publicDashboardEvents = dashboardEvents.filter((eventItem)=>isPubliclyAccessible(eventItem) && !eventItem.isPremium);
    const premiumDashboardEvents = dashboardEvents.filter((eventItem)=>isPubliclyAccessible(eventItem) && !!eventItem.isPremium);
    const organiserEditableEvents = allEvents.filter(canEditEvent).filter((f)=>{
        var ref;
        return ((ref = f.event) === null || ref === void 0 ? void 0 : ref.organizationName) === (profile === null || profile === void 0 ? void 0 : profile.company);
    });
    const adminAccessibleEvents = allEvents.filter(isPubliclyAccessible);
    const adminDraftEvents = allEvents.filter((eventItem)=>!eventItem.isPublished || !eventItem.isComplete);
    const router = (0,next_router.useRouter)();
    // NOTE: Handles the toast popup when a user completes the signup to login flow.
    (0,react.useEffect)(()=>{
        const existingLogin = new URLSearchParams(document.location.search).has("existinglogin");
        if (existingLogin && isReady) {
            (0,dist/* default */.ZP)("Logged in to your exisiting account, using the provided credentials.", {
                icon: "\uD83D\uDCAC",
                duration: 8000
            });
        }
    }, [
        isReady
    ]);
    const handleUpdateOrganisation = async (param)=>{
        let { bannerImage , headerTextOne , headerTextTwo  } = param;
        var ref;
        const companyName = (ref = organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.company;
        if (companyName) {
            let variables = {
                name: companyName
            };
            if (bannerImage) variables.bannerImage = bannerImage;
            if (headerTextOne) variables.headerTextOne = headerTextOne;
            if (headerTextTwo) variables.headerTextTwo = headerTextTwo;
            await updateOrganisation({
                variables
            });
            setTimeout(()=>{
                refetchOrganisation();
            }, 500);
        }
    };
    var ref8;
    const headerBanner = (ref8 = organisationBanner !== null && organisationBanner !== void 0 ? organisationBanner : organisationData === null || organisationData === void 0 ? void 0 : organisationData.bannerImage) !== null && ref8 !== void 0 ? ref8 : header_background/* default.src */.Z.src;
    if (!profile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {});
    }
    if (!isReady || organisationLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex-1 overflow-y-scroll h-[calc(100vh)] relative flex items-center flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {})
        });
    }
    const isDarkTheme = theme.type === "DARK";
    const headerTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Welcome to your ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            company,
            " Space"
        ]
    });
    const headerSubTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Here you’ll discover all the events you’ve signed up to along with the events you’ve created."
    });
    const totalAccountEvents = allEvents.filter(canEditEvent).length;
    const canCreateEvents = !!isOrganizer || !!isAdmin;
    // Sets the theme back to Forumm's when on the dashboard.
    if (!!theme && !!theme.organisationName && theme.organisationName !== "Forumm") setTheme({
        ...theme,
        organisationName: "Forumm"
    });
    const renderEventSection = (param)=>{
        let { title , events , loading , emptyMessage ="No events match your search yet."  } = param;
        const visibleEvents = (events !== null && events !== void 0 ? events : []).filter((eventItem)=>{
            var ref, ref1, ref2, ref3;
            var ref4;
            if (!filterTypes.includes((ref4 = (ref = eventItem.event) === null || ref === void 0 ? void 0 : ref.eventType) !== null && ref4 !== void 0 ? ref4 : "")) return false;
            if (!term) return true;
            const searchableText = [
                (ref1 = eventItem.event) === null || ref1 === void 0 ? void 0 : ref1.title,
                (ref2 = eventItem.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName,
                (ref3 = eventItem.event) === null || ref3 === void 0 ? void 0 : ref3.shortDescription
            ].filter(Boolean).join(" ").toLowerCase();
            return searchableText.includes(term.toLowerCase());
        });
        const hasEvents = visibleEvents.length > 0;
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    className: "text-2xl font-medium -mb-2 mt-16 pl-5 sm:pl-0 ml-0 flex items-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "rounded-full bg-white/10 px-2 py-1 text-xs",
                            children: visibleEvents.length
                        }),
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                            style: {
                                borderTopColor: "rgb(24, 26, 32)"
                            }
                        })
                    ]
                }),
                hasEvents ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                    events: visibleEvents,
                    types: filterTypes,
                    title: "",
                    currency: (ref = organisationData === null || organisationData === void 0 ? void 0 : organisationData.currency) !== null && ref !== void 0 ? ref : "GBP"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: "pt-12 pb-12 text-base text-center",
                    children: emptyMessage
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-1 -mt-[80px] pt-[80px] overflow-y-scroll overflow-x-hidden h-[calc(100vh)] items-center flex-col relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "relative sm:flex justify-center w-full md:min-h-[25rem]",
                style: {
                    backgroundImage: "url(".concat(headerBanner, ")"),
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundColor: theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "lg:min-w-[57rem] z-999 relative w-full flex justify-center items-center ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            show: isOrganizer,
                            className: "absolute cursor-pointer top-5 right-5 z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                                uploadFile: uploadFile,
                                crop: true,
                                cropAspectRatio: 4,
                                cropShape: "rect",
                                value: organisationBanner,
                                onChange: (data)=>{
                                    setOrganisationBanner(data);
                                    if (typeof data === "string" && data.length > 0) {
                                        handleUpdateOrganisation({
                                            bannerImage: data
                                        });
                                    }
                                },
                                minified: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "rounded-2xl shadow-lg md:w-[85%] max-w-[1500px] flex p-10 md:p-6 md:px-8 md:py-4 md:pt-6 md:pb-6 z-1000 animate-text-focus-in ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                            color: "backgroundColorBanner",
                            style: {
                                background: isDarkTheme ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.6)",
                                backdropFilter: "blur(5px)",
                                WebkitBackdropFilter: "blur(5px)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "px-6 lg:px-0 z-1000 relative w-full",
                                children: [
                                    isOrganizer && /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_OrganizationBannerEditPopup, {
                                        headerTextOne: organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne,
                                        headerTextTwo: organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo,
                                        onSave: (headerTextOne, headerTextTwo)=>{
                                            handleUpdateOrganisation({
                                                headerTextOne,
                                                headerTextTwo
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "text-4xl font-medium pb-4 text-center leading-snug mt-2 px-12 sm:px-0 mb-2",
                                        children: headerTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: "text-base text-center px-12 sm:px-6 animate-text-focus-in",
                                            children: headerSubTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "mt-4",
                                            title: "Create Event",
                                            onClick: ()=>router.push("/create-event")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "pl-12 mt-6 sm:pl-0 sm:flex sm:flex-row-reverse justify-between md:w-[85%] max-w-[1500px] px-3 sm:p-0 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "my-2 sm:my-0 ml-2 sm:ml-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_SearchEvent, {
                        searchTerm: term,
                        setSearchTerm: (inputText)=>setTerm(inputText)
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "pl-10 sm:pl-0 sm:flex sm:flex-row-reverse justify-between md:w-[85%] max-w-[1500px] px-3 sm:p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "text-white p-2 py-6 pt-0 w-full",
                    children: [
                        renderEventSection({
                            title: "My Events",
                            events: myEvents,
                            loading: myEventsLoading,
                            emptyMessage: "No registered events match your search."
                        }),
                        renderEventSection({
                            title: "Find Public Events",
                            events: publicDashboardEvents,
                            loading: dashboardEventsLoading,
                            emptyMessage: "No public events match your search."
                        }),
                        renderEventSection({
                            title: "Premium Events",
                            events: premiumDashboardEvents,
                            loading: dashboardEventsLoading,
                            emptyMessage: "No premium events match your search."
                        }),
                        isOrganizer && renderEventSection({
                            title: "".concat(profile.company, " Events"),
                            events: organiserEditableEvents,
                            loading: allEventsLoading,
                            emptyMessage: "No editable events match your search."
                        }),
                        isAdmin && renderEventSection({
                            title: "Admin: Public Events",
                            events: adminAccessibleEvents,
                            loading: allEventsLoading,
                            emptyMessage: "No accessible events match your search."
                        }),
                        isAdmin && renderEventSection({
                            title: "Admin: Drafts Events",
                            events: adminDraftEvents,
                            loading: allEventsLoading,
                            emptyMessage: "No draft events match your search."
                        })
                    ]
                })
            }),
            isReady && canCreateEvents && !organisationLoading && !myEventsLoading && !dashboardEventsLoading && !allEventsLoading && totalAccountEvents === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "secondary",
                    size: "large",
                    title: "Create your first event",
                    className: "mt-10 mb-20",
                    onClick: ()=>router.push("/create-event")
                })
            }),
            isOrganizer && !organisationLoading && organisationReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_StylingModal, {
                organisationData: organisationData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                transparent: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                toastOptions: {
                    className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                    duration: 4000
                }
            })
        ]
    });
}
OrganizerLaunchPage.Layout = layouts_DashboardLayout;


/***/ })

}]);